import { img } from "@/lib/images";

export interface Tour {
  slug: string;
  category: "day-trip" | "multi-day" | "adventure";
  titleKey: string;
  subtitleKey: string;
  image: string;
  sliderImages?: { src: string; alt: string }[];
  tagKey: string;
  durationKey: string;
  priceKey?: string;
  priceChildKey?: string;
  priceOnRequest?: boolean;
  detailDescKey: string;
  startValueKey?: string;
  startLabelKey?: string;
  hasItinerary: boolean;
  itineraryDays?: number;
  itineraryPrefixKey?: string;
  highlightsKey: string;
  includedKeys: string[];
  backPath: string;
  backLabelKey: string;
  bookingValue?: string;
  routeMapImage?: string;
  isRafting?: boolean;
  isSailing?: boolean;
  isDiving?: boolean;
  externalLink?: string;
  relatedSlugs: string[];
}

export const tours: Tour[] = [
  // Day trips
  {
    slug: "day-trip-1",
    bookingValue: "Tour 1 – Die klassische Tour",
    category: "day-trip",
    titleKey: "daytrip_1_title",
    subtitleKey: "daytrip_1_subtitle",
    image: img("activities/day-trips/day-trips-tour1-01.jpg"),
    sliderImages: [
      { src: img("activities/day-trips/day-trip-1/tour-01-slider-01.jpg"), alt: "Bali Tanah Lot Tempel" },
      { src: img("activities/day-trips/day-trip-1/tour-01-slider-02.jpg"), alt: "Bali Pura Luhur Tempel Batu Karu" },
      { src: img("activities/day-trips/day-trip-1/tour-01-slider-03.jpg"), alt: "Bali Reis Terrassen bei Jati Luwih" },
      { src: img("activities/day-trips/day-trip-1/tour-01-slider-04.jpg"), alt: "Bali Früchtemarkt bei Bedugul" },
      { src: img("activities/day-trips/day-trip-1/tour-01-slider-05.jpg"), alt: "Bali Pura Danu Beratan Tempel" },
      { src: img("activities/day-trips/day-trip-1/tour-01-slider-06.jpg"), alt: "Bali Kinder an der Straße" },
    ],
    tagKey: "daytrip_1_tag",
    durationKey: "daytrip_1_duration",
    priceKey: "day_trip",
    priceChildKey: "day_trip_child",
    detailDescKey: "daytrip_1_detail",
    hasItinerary: false,
    highlightsKey: "daytrip_1_highlights",
    includedKeys: ["tour_included_1", "tour_included_3", "tour_included_4", "tour_included_5"],
    backPath: "/day-trips",
    backLabelKey: "tour_detail_back_daytrips",
    relatedSlugs: ["day-trip-2", "day-trip-3", "day-trip-4"],
    routeMapImage: img("activities/maps-tour-routes/tour-01.png"),
  },
  {
    slug: "day-trip-2",
    bookingValue: "Tour 2 – Das versteckte Bali",
    category: "day-trip",
    titleKey: "daytrip_2_title",
    subtitleKey: "daytrip_2_subtitle",
    image: img("activities/day-trips/day-trips-tour2-01.jpg"),
    sliderImages: [
      { src: img("activities/day-trips/day-trip-2/tour-02-slider-01.jpg"), alt: "Bali Taman Ayun Tempel" },
      { src: img("activities/day-trips/day-trip-2/tour-02-slider-02.jpg"), alt: "Bali Landschaft bei Mengwi" },
      { src: img("activities/day-trips/day-trip-2/tour-02-slider-03.jpg"), alt: "Traditioneller Bali Markt" },
      { src: img("activities/day-trips/day-trip-2/tour-02-slider-04.jpg"), alt: "Bananenverkäufer auf Bali" },
      { src: img("activities/day-trips/day-trip-2/tour-02-slider-05.jpg"), alt: "Regenwaldwanderung auf Bali" },
      { src: img("activities/day-trips/day-trip-2/tour-02-slider-06.jpg"), alt: "Traditionelles Bali Bergdorf" },
      { src: img("activities/day-trips/day-trip-2/tour-02-slider-07.jpg"), alt: "Bali Makaken Affe" },
    ],
    tagKey: "daytrip_2_tag",
    durationKey: "daytrip_2_duration",
    priceKey: "day_trip",
    priceChildKey: "day_trip_child",
    detailDescKey: "daytrip_2_detail",
    hasItinerary: false,
    highlightsKey: "daytrip_2_highlights",
    includedKeys: ["tour_included_1", "tour_included_3", "tour_included_4", "tour_included_5"],
    backPath: "/day-trips",
    backLabelKey: "tour_detail_back_daytrips",
    relatedSlugs: ["day-trip-1", "day-trip-3", "day-trip-5"],
    routeMapImage: img("activities/maps-tour-routes/tour-02.png"),
  },
  {
    slug: "day-trip-3",
    bookingValue: "Tour 3 – Reisfeldwanderung",
    category: "day-trip",
    titleKey: "daytrip_3_title",
    subtitleKey: "daytrip_3_subtitle",
    image: img("activities/day-trips/day-trips-tour3-01.jpg"),
    sliderImages: [
      { src: img("activities/day-trips/day-trip-3/tour-03-slider-01.jpg"), alt: "Bali Reismuseum in Tabanan" },
      { src: img("activities/day-trips/day-trip-3/tour-03-slider-02.jpg"), alt: "Bali Reisfeldwanderung" },
      { src: img("activities/day-trips/day-trip-3/tour-03-slider-03.jpg"), alt: "Bali Reispflanzer" },
      { src: img("activities/day-trips/day-trip-3/tour-03-slider-04.jpg"), alt: "Bali Reisbauer beim Pflügen" },
      { src: img("activities/day-trips/day-trip-3/tour-03-slider-05.jpg"), alt: "Bali Reisernte" },
      { src: img("activities/day-trips/day-trip-3/tour-03-slider-06.jpg"), alt: "Bali Reisernte" },
    ],
    tagKey: "daytrip_3_tag",
    durationKey: "daytrip_3_duration",
    priceKey: "day_trip",
    priceChildKey: "day_trip_child",
    detailDescKey: "daytrip_3_detail",
    hasItinerary: false,
    highlightsKey: "daytrip_3_highlights",
    includedKeys: ["tour_included_1", "tour_included_3", "tour_included_4", "tour_included_5"],
    backPath: "/day-trips",
    backLabelKey: "tour_detail_back_daytrips",
    relatedSlugs: ["day-trip-1", "day-trip-2", "day-trip-6"],
    routeMapImage: img("activities/maps-tour-routes/tour-03.png"),
  },
  {
    slug: "day-trip-4",
    bookingValue: "Tour 4 – Ost Bali",
    category: "day-trip",
    titleKey: "daytrip_4_title",
    subtitleKey: "daytrip_4_subtitle",
    image: img("activities/day-trips/day-trips-tour4-01.jpg"),
    sliderImages: [
      { src: img("activities/day-trips/day-trip-4/tour-04-slider-01.jpg"), alt: "Bali Goa Gajah Elefantenhöhle" },
      { src: img("activities/day-trips/day-trip-4/tour-04-slider-02.jpg"), alt: "Bali Ikat Weberei" },
      { src: img("activities/day-trips/day-trip-4/tour-04-slider-03.jpg"), alt: "Bali Ikat Webstoffe" },
      { src: img("activities/day-trips/day-trip-4/tour-04-slider-04.jpg"), alt: "Bali Gunung Agung Vulkan" },
      { src: img("activities/day-trips/day-trip-4/tour-04-slider-05.jpg"), alt: "Bali Pura Kehen in Bangli" },
      { src: img("activities/day-trips/day-trip-4/tour-04-slider-06.jpg"), alt: "Bali Candidasa Dorfbild" },
      { src: img("activities/day-trips/day-trip-4/tour-04-slider-07.jpg"), alt: "Bali Salzherstellung" },
    ],
    tagKey: "daytrip_4_tag",
    durationKey: "daytrip_4_duration",
    priceKey: "day_trip",
    priceChildKey: "day_trip_child",
    detailDescKey: "daytrip_4_detail",
    hasItinerary: false,
    highlightsKey: "daytrip_4_highlights",
    includedKeys: ["tour_included_1", "tour_included_3", "tour_included_4", "tour_included_5"],
    backPath: "/day-trips",
    backLabelKey: "tour_detail_back_daytrips",
    relatedSlugs: ["day-trip-1", "day-trip-5", "day-trip-7"],
    routeMapImage: img("activities/maps-tour-routes/tour-04.png"),
  },
  {
    slug: "day-trip-5",
    bookingValue: "Tour 5 – Batur Vulkanbesteigung",
    category: "day-trip",
    titleKey: "daytrip_5_title",
    subtitleKey: "daytrip_5_subtitle",
    image: img("activities/day-trips/day-trips-tour5-01.jpg"),
    sliderImages: [
      { src: img("activities/day-trips/day-trip-5/tour-05-slider-01.jpg"), alt: "Bali Batur Vulkangebietskarte" },
      { src: img("activities/day-trips/day-trip-5/tour-05-slider-02.jpg"), alt: "Bali Batur Vulkanbesteigung" },
      { src: img("activities/day-trips/day-trip-5/tour-05-slider-03.jpg"), alt: "Bali Batur Vulkanbesteigung Aufstieg" },
      { src: img("activities/day-trips/day-trip-5/tour-05-slider-04.jpg"), alt: "Bali Batur Kraterrand" },
      { src: img("activities/day-trips/day-trip-5/tour-05-slider-05.jpg"), alt: "Bali Batur Vulkan" },
      { src: img("activities/day-trips/day-trip-5/tour-05-slider-06.jpg"), alt: "Bali Batur Vulkan Panorama" },
    ],
    tagKey: "daytrip_5_tag",
    durationKey: "daytrip_5_duration",
    priceKey: "day_trip",
    priceChildKey: "day_trip_child",
    detailDescKey: "daytrip_5_detail",
    hasItinerary: false,
    highlightsKey: "daytrip_5_highlights",
    includedKeys: ["tour_included_1", "tour_included_3", "tour_included_4", "tour_included_5"],
    backPath: "/day-trips",
    backLabelKey: "tour_detail_back_daytrips",
    relatedSlugs: ["day-trip-2", "day-trip-6", "day-trip-7"],
    routeMapImage: img("activities/maps-tour-routes/tour-05.png"),
  },
  {
    slug: "day-trip-6",
    bookingValue: "Tour 6 – Bali Natur in Westbali",
    category: "day-trip",
    titleKey: "daytrip_6_title",
    subtitleKey: "daytrip_6_subtitle",
    image: img("activities/day-trips/day-trips-tour6-01.jpg"),
    sliderImages: [
      { src: img("activities/day-trips/day-trip-6/tour-06-slider-01.jpg"), alt: "Bali Dachziegel Herstellung in Pejaten" },
      { src: img("activities/day-trips/day-trip-6/tour-06-slider-02.jpg"), alt: "Bali Keramik Herstellung in Pejaten" },
      { src: img("activities/day-trips/day-trip-6/tour-06-slider-03.jpg"), alt: "Bali Reisterrassen von Westbali" },
      { src: img("activities/day-trips/day-trip-6/tour-06-slider-04.jpg"), alt: "Bali Regenwaldgebiet in Westbali" },
      { src: img("activities/day-trips/day-trip-6/tour-06-slider-05.jpg"), alt: "Bali Dorfbewohner" },
      { src: img("activities/day-trips/day-trip-6/tour-06-slider-06.jpg"), alt: "Bali Buyan Kratersee" },
      { src: img("activities/day-trips/day-trip-6/tour-06-slider-07.jpg"), alt: "Bali Natur in Westbali" },
      { src: img("activities/day-trips/day-trip-6/tour-06-slider-08.jpg"), alt: "Bali Natur in Westbali" },
    ],
    tagKey: "daytrip_6_tag",
    durationKey: "daytrip_6_duration",
    priceKey: "day_trip",
    priceChildKey: "day_trip_child",
    detailDescKey: "daytrip_6_detail",
    hasItinerary: false,
    highlightsKey: "daytrip_6_highlights",
    includedKeys: ["tour_included_1", "tour_included_3", "tour_included_4", "tour_included_5"],
    backPath: "/day-trips",
    backLabelKey: "tour_detail_back_daytrips",
    relatedSlugs: ["day-trip-3", "day-trip-5", "day-trip-7"],
    routeMapImage: img("activities/maps-tour-routes/tour-06.png"),
  },
  {
    slug: "day-trip-7",
    bookingValue: "Tour 7 – Balis Künstler",
    category: "day-trip",
    titleKey: "daytrip_7_title",
    subtitleKey: "daytrip_7_subtitle",
    image: img("activities/day-trips/day-trips-tour7-01.jpg"),
    sliderImages: [
      { src: img("activities/day-trips/day-trip-7/tour-07-slider-01.jpg"), alt: "Bali Barong Tanzaufführung" },
      { src: img("activities/day-trips/day-trip-7/tour-07-slider-02.jpg"), alt: "Bali Sandsteinfiguren in Batubulan" },
      { src: img("activities/day-trips/day-trip-7/tour-07-slider-03.jpg"), alt: "Bali Silberschmiede in Celuk" },
      { src: img("activities/day-trips/day-trip-7/tour-07-slider-04.jpg"), alt: "Bali Silberschmuck" },
      { src: img("activities/day-trips/day-trip-7/tour-07-slider-05.jpg"), alt: "Bali Ubud Bildergalerie" },
      { src: img("activities/day-trips/day-trip-7/tour-07-slider-06.jpg"), alt: "Bali Ubud Einkaufsstraße" },
    ],
    tagKey: "daytrip_7_tag",
    durationKey: "daytrip_7_duration",
    priceKey: "day_trip",
    priceChildKey: "day_trip_child",
    detailDescKey: "daytrip_7_detail",
    hasItinerary: false,
    highlightsKey: "daytrip_7_highlights",
    includedKeys: ["tour_included_1", "tour_included_3", "tour_included_4", "tour_included_5"],
    backPath: "/day-trips",
    backLabelKey: "tour_detail_back_daytrips",
    relatedSlugs: ["day-trip-4", "day-trip-5", "day-trip-6"],
    routeMapImage: img("activities/maps-tour-routes/tour-07.png"),
  },
  // Multi-day tours
  {
    slug: "multi-day-8",
    bookingValue: "Tour 8 – Bali Natur & Künstler",
    category: "multi-day",
    titleKey: "multiday_8_title",
    subtitleKey: "multiday_8_subtitle",
    image: img("activities/day-trips/day-trips-tour6-01.jpg"),
    sliderImages: [
      { src: img("activities/day-trips/day-trip-6/tour-06-slider-01.jpg"), alt: "Töpferdorf Pejaten auf Bali" },
      { src: img("activities/day-trips/day-trip-6/tour-06-slider-03.jpg"), alt: "Reisterrassen im Westen Balis" },
      { src: img("activities/day-trips/day-trip-6/tour-06-slider-04.jpg"), alt: "Regenwaldgebiet im Westen Balis" },
      { src: img("activities/day-trips/day-trip-6/tour-06-slider-06.jpg"), alt: "Kratersee Buyan auf Bali" },
      { src: img("activities/day-trips/day-trip-7/tour-07-slider-02.jpg"), alt: "Steinmetze von Batubulan" },
      { src: img("activities/day-trips/day-trip-7/tour-07-slider-03.jpg"), alt: "Silberschmiede in Celuk" },
      { src: img("activities/day-trips/day-trip-7/tour-07-slider-05.jpg"), alt: "Künstlerdorf Ubud" },
    ],
    tagKey: "multiday_8_tag",
    durationKey: "multiday_8_duration",
    priceKey: "roundtrip_8_adult",
    priceChildKey: "roundtrip_8_child",
    detailDescKey: "multiday_8_desc",
    hasItinerary: true,
    itineraryDays: 2,
    itineraryPrefixKey: "multiday_8_day",
    highlightsKey: "multiday_8_highlights",
    includedKeys: ["tour_included_1", "tour_included_3", "tour_included_4", "tour_included_5", "tour_included_6"],
    backPath: "/multi-day-tours",
    backLabelKey: "tour_detail_back_multiday",
    relatedSlugs: ["multi-day-9", "multi-day-10"],
    routeMapImage: img("activities/maps-tour-routes/tour-08.png"),
  },
  {
    slug: "multi-day-9",
    bookingValue: "Tour 9 – Impressionen Balis",
    category: "multi-day",
    titleKey: "multiday_9_title",
    subtitleKey: "multiday_9_subtitle",
    image: img("activities/day-trips/day-trips-tour1-01.jpg"),
    sliderImages: [
      { src: img("activities/day-trips/day-trip-1/tour-01-slider-01.jpg"), alt: "Meerestempel Tanah Lot" },
      { src: img("activities/day-trips/day-trip-1/tour-01-slider-03.jpg"), alt: "Reisterrassen bei Jatiluwih" },
      { src: img("activities/day-trips/day-trip-1/tour-01-slider-05.jpg"), alt: "Ulun Danu Tempel am Bratan See" },
      { src: img("activities/day-trips/day-trip-2/tour-02-slider-01.jpg"), alt: "Taman Ayun Tempel in Mengwi" },
      { src: img("activities/day-trips/day-trip-2/tour-02-slider-03.jpg"), alt: "Traditioneller balinesischer Dorfmarkt" },
      { src: img("activities/day-trips/day-trip-2/tour-02-slider-07.jpg"), alt: "Heilige Affen im Muskatnusswald" },
      { src: img("activities/day-trips/day-trip-7/tour-07-slider-04.jpg"), alt: "Silberschmuck aus Celuk" },
      { src: img("activities/day-trips/day-trip-7/tour-07-slider-06.jpg"), alt: "Einkaufsstraße in Ubud" },
    ],
    tagKey: "multiday_9_tag",
    durationKey: "multiday_9_duration",
    priceKey: "roundtrip_9_adult",
    priceChildKey: "roundtrip_9_child",
    detailDescKey: "multiday_9_desc",
    hasItinerary: true,
    itineraryDays: 3,
    itineraryPrefixKey: "multiday_9_day",
    highlightsKey: "multiday_9_highlights",
    includedKeys: ["tour_included_1", "tour_included_3", "tour_included_4", "tour_included_5", "tour_included_6"],
    backPath: "/multi-day-tours",
    backLabelKey: "tour_detail_back_multiday",
    relatedSlugs: ["multi-day-8", "multi-day-10"],
    routeMapImage: img("activities/maps-tour-routes/tour-09.png"),
  },
  {
    slug: "multi-day-10",
    bookingValue: "Tour 10 – Klassische Bali Rundreise",
    category: "multi-day",
    titleKey: "multiday_1_title",
    subtitleKey: "multiday_1_subtitle",
    image: img("activities/multi-day-tours/multi-day-tours-tour10-01.jpg"),
    sliderImages: [
      { src: img("activities/multi-day-tours/multi-day-10/tour-10-slider-01.jpg"), alt: "Bali Rundreise – klassische Route" },
      { src: img("activities/multi-day-tours/multi-day-10/tour-10-slider-02.jpg"), alt: "Bali Rundreise – klassische Route" },
      { src: img("activities/multi-day-tours/multi-day-10/tour-10-slider-03.jpg"), alt: "Bali Rundreise – klassische Route" },
      { src: img("activities/multi-day-tours/multi-day-10/tour-10-slider-04.jpg"), alt: "Bali Rundreise – klassische Route" },
      { src: img("activities/multi-day-tours/multi-day-10/tour-10-slider-05.jpg"), alt: "Bali Rundreise – klassische Route" },
      { src: img("activities/multi-day-tours/multi-day-10/tour-16-slider-06.jpg"), alt: "Bali Rundreise – klassische Route" },
      { src: img("activities/multi-day-tours/multi-day-10/tour-16-slider-07.jpg"), alt: "Bali Rundreise – klassische Route" },
      { src: img("activities/multi-day-tours/multi-day-10/tour-16-slider-08.jpg"), alt: "Bali Rundreise – klassische Route" },
      { src: img("activities/multi-day-tours/multi-day-10/tour-16-slider-09.jpg"), alt: "Bali Rundreise – klassische Route" },
      { src: img("activities/multi-day-tours/multi-day-10/tour-16-slider-10.jpg"), alt: "Bali Rundreise – klassische Route" },
      { src: img("activities/multi-day-tours/multi-day-10/tour-16-slider-11.jpg"), alt: "Bali Rundreise – klassische Route" },
      { src: img("activities/multi-day-tours/multi-day-10/tour-16-slider-12.jpg"), alt: "Bali Rundreise – klassische Route" },
      { src: img("activities/multi-day-tours/multi-day-10/tour-16-slider-13.jpg"), alt: "Bali Rundreise – klassische Route" },
      { src: img("activities/multi-day-tours/multi-day-10/tour-16-slider-14.jpg"), alt: "Bali Rundreise – klassische Route" },
      { src: img("activities/multi-day-tours/multi-day-10/tour-16-slider-15.jpg"), alt: "Bali Rundreise – klassische Route" },
      { src: img("activities/multi-day-tours/multi-day-10/tour-16-slider-16.jpg"), alt: "Bali Rundreise – klassische Route" },
    ],
    tagKey: "multiday_1_tag",
    durationKey: "multiday_1_duration",
    priceKey: "roundtrip_10_adult",
    priceChildKey: "roundtrip_10_child",
    detailDescKey: "multiday_1_desc",
    hasItinerary: true,
    itineraryDays: 4,
    itineraryPrefixKey: "multiday_10_day",
    highlightsKey: "multiday_10_highlights",
    includedKeys: ["tour_included_1", "tour_included_3", "tour_included_4", "tour_included_5", "tour_included_6"],
    backPath: "/multi-day-tours",
    backLabelKey: "tour_detail_back_multiday",
    relatedSlugs: ["multi-day-11", "multi-day-12"],
    routeMapImage: img("activities/maps-tour-routes/tour-10.png"),
  },
  {
    slug: "multi-day-11",
    bookingValue: "Tour 11 – Bali Rundreise mit Batur",
    category: "multi-day",
    titleKey: "multiday_2_title",
    subtitleKey: "multiday_2_subtitle",
    image: img("activities/multi-day-tours/multi-day-tours-tour11-01.jpg"),
    sliderImages: [
      { src: img("activities/multi-day-tours/multi-day-11/tour-11-slider-01.jpg"), alt: "Bali Rundreise mit Batur" },
      { src: img("activities/multi-day-tours/multi-day-11/tour-11-slider-02.jpg"), alt: "Bali Rundreise mit Batur" },
      { src: img("activities/multi-day-tours/multi-day-11/tour-11-slider-03.jpg"), alt: "Bali Rundreise mit Batur" },
      { src: img("activities/multi-day-tours/multi-day-11/tour-11-slider-04.jpg"), alt: "Bali Rundreise mit Batur" },
      { src: img("activities/multi-day-tours/multi-day-11/tour-11-slider-05.jpg"), alt: "Bali Rundreise mit Batur" },
      { src: img("activities/multi-day-tours/multi-day-11/tour-11-slider-06.jpg"), alt: "Bali Rundreise mit Batur" },
      { src: img("activities/multi-day-tours/multi-day-11/tour-11-slider-07.jpg"), alt: "Bali Rundreise mit Batur" },
      { src: img("activities/multi-day-tours/multi-day-11/tour-11-slider-08.jpg"), alt: "Bali Rundreise mit Batur" },
      { src: img("activities/multi-day-tours/multi-day-11/tour-11-slider-09.jpg"), alt: "Bali Rundreise mit Batur" },
      { src: img("activities/multi-day-tours/multi-day-11/tour-11-slider-10.jpg"), alt: "Bali Rundreise mit Batur" },
      { src: img("activities/multi-day-tours/multi-day-11/tour-11-slider-11.jpg"), alt: "Bali Rundreise mit Batur" },
      { src: img("activities/multi-day-tours/multi-day-11/tour-11-slider-12.jpg"), alt: "Bali Rundreise mit Batur" },
      { src: img("activities/multi-day-tours/multi-day-11/tour-11-slider-13.jpg"), alt: "Bali Rundreise mit Batur" },
      { src: img("activities/multi-day-tours/multi-day-11/tour-11-slider-14.jpg"), alt: "Bali Rundreise mit Batur" },
      { src: img("activities/multi-day-tours/multi-day-11/tour-11-slider-15.jpg"), alt: "Bali Rundreise mit Batur" },
      { src: img("activities/multi-day-tours/multi-day-11/tour-11-slider-16.jpg"), alt: "Bali Rundreise mit Batur" },
      { src: img("activities/multi-day-tours/multi-day-11/tour-11-slider-17.jpg"), alt: "Bali Rundreise mit Batur" },
    ],
    tagKey: "multiday_2_tag",
    durationKey: "multiday_2_duration",
    priceKey: "roundtrip_11_adult",
    priceChildKey: "roundtrip_11_child",
    detailDescKey: "multiday_2_desc",
    hasItinerary: true,
    itineraryDays: 4,
    itineraryPrefixKey: "multiday_11_day",
    highlightsKey: "multiday_11_highlights",
    includedKeys: ["tour_included_1", "tour_included_3", "tour_included_4", "tour_included_5", "tour_included_6"],
    backPath: "/multi-day-tours",
    backLabelKey: "tour_detail_back_multiday",
    relatedSlugs: ["multi-day-10", "multi-day-12"],
    routeMapImage: img("activities/maps-tour-routes/tour-11.png"),
  },
  {
    slug: "multi-day-12",
    bookingValue: "Tour 12 – Rundreise mit Kulturprogramm",
    category: "multi-day",
    titleKey: "multiday_3_title",
    subtitleKey: "multiday_3_subtitle",
    image: img("activities/multi-day-tours/multidaytours-tour12-01.jpg"),
    sliderImages: [
      { src: img("activities/multi-day-tours/multi-day-12/tour-12-slider-01.jpg"), alt: "Rundreise mit Kulturprogramm" },
      { src: img("activities/multi-day-tours/multi-day-12/tour-12-slider-02.jpg"), alt: "Rundreise mit Kulturprogramm" },
      { src: img("activities/multi-day-tours/multi-day-12/tour-12-slider-03.jpg"), alt: "Rundreise mit Kulturprogramm" },
      { src: img("activities/multi-day-tours/multi-day-12/tour-12-slider-04.jpg"), alt: "Rundreise mit Kulturprogramm" },
      { src: img("activities/multi-day-tours/multi-day-12/tour-12-slider-05.jpg"), alt: "Rundreise mit Kulturprogramm" },
      { src: img("activities/multi-day-tours/multi-day-12/tour-12-slider-06.jpg"), alt: "Rundreise mit Kulturprogramm" },
      { src: img("activities/multi-day-tours/multi-day-12/tour-12-slider-07.jpg"), alt: "Rundreise mit Kulturprogramm" },
      { src: img("activities/multi-day-tours/multi-day-12/tour-12-slider-08.jpg"), alt: "Rundreise mit Kulturprogramm" },
      { src: img("activities/multi-day-tours/multi-day-12/tour-12-slider-09.jpg"), alt: "Rundreise mit Kulturprogramm" },
      { src: img("activities/multi-day-tours/multi-day-12/tour-12-slider-10.jpg"), alt: "Rundreise mit Kulturprogramm" },
      { src: img("activities/multi-day-tours/multi-day-12/tour-12-slider-11.jpg"), alt: "Rundreise mit Kulturprogramm" },
      { src: img("activities/multi-day-tours/multi-day-12/tour-12-slider-12.jpg"), alt: "Rundreise mit Kulturprogramm" },
      { src: img("activities/multi-day-tours/multi-day-12/tour-12-slider-13.jpg"), alt: "Rundreise mit Kulturprogramm" },
      { src: img("activities/multi-day-tours/multi-day-12/tour-12-slider-14.jpg"), alt: "Rundreise mit Kulturprogramm" },
      { src: img("activities/multi-day-tours/multi-day-12/tour-12-slider-15.jpg"), alt: "Rundreise mit Kulturprogramm" },
      { src: img("activities/multi-day-tours/multi-day-12/tour-12-slider-16.jpg"), alt: "Rundreise mit Kulturprogramm" },
      { src: img("activities/multi-day-tours/multi-day-12/tour-12-slider-17.jpg"), alt: "Rundreise mit Kulturprogramm" },
      { src: img("activities/multi-day-tours/multi-day-12/tour-12-slider-18.jpg"), alt: "Rundreise mit Kulturprogramm" },
      { src: img("activities/multi-day-tours/multi-day-12/tour-12-slider-19.jpg"), alt: "Rundreise mit Kulturprogramm" },
      { src: img("activities/multi-day-tours/multi-day-12/tour-12-slider-20.jpg"), alt: "Rundreise mit Kulturprogramm" },
      { src: img("activities/multi-day-tours/multi-day-12/tour-12-slider-21.jpg"), alt: "Rundreise mit Kulturprogramm" },
      { src: img("activities/multi-day-tours/multi-day-12/tour-12-slider-22.jpg"), alt: "Rundreise mit Kulturprogramm" },
    ],
    tagKey: "multiday_3_tag",
    durationKey: "multiday_3_duration",
    priceKey: "roundtrip_12_adult",
    priceChildKey: "roundtrip_12_child",
    detailDescKey: "multiday_3_desc",
    hasItinerary: true,
    itineraryDays: 5,
    itineraryPrefixKey: "multiday_12_day",
    highlightsKey: "multiday_12_highlights",
    includedKeys: ["tour_included_1", "tour_included_3", "tour_included_4", "tour_included_5", "tour_included_6"],
    backPath: "/multi-day-tours",
    backLabelKey: "tour_detail_back_multiday",
    relatedSlugs: ["multi-day-10", "multi-day-11"],
    routeMapImage: img("activities/maps-tour-routes/tour-12.png"),
  },
  {
    slug: "adventure-01",
    category: "adventure",
    titleKey: "adventure_1_title",
    subtitleKey: "adventure_1_title",
    image: img("activities/adventure-tours/adventure-1/header-adventure-1.jpg"),
    tagKey: "adventure_1_tag",
    durationKey: "adventure_1_duration",
    priceKey: "rafting",
    isRafting: true,
    detailDescKey: "adventure_1_detail",
    hasItinerary: false,
    highlightsKey: "adventure_1_highlights",
    includedKeys: ["tour_included_1", "tour_included_3", "tour_included_4"],
    backPath: "/adventure-tours",
    backLabelKey: "tour_detail_back_adventure",
    relatedSlugs: ["adventure-02", "adventure-03"],
    startValueKey: "adventure_1_start",
    startLabelKey: "adventure_1_start_label",
  },
  {
    slug: "adventure-02",
    category: "adventure",
    titleKey: "adventure_2_title",
    subtitleKey: "adventure_2_title",
    image: img("activities/adventure-tours/adventure-2/header-sailing-01.jpg"),
    tagKey: "adventure_2_tag",
    durationKey: "adventure_2_duration",
    priceKey: "sailing",
    detailDescKey: "adventure_2_detail",
    hasItinerary: false,
    highlightsKey: "adventure_2_highlights",
    includedKeys: ["tour_included_1", "tour_included_3", "tour_included_4"],
    backPath: "/adventure-tours",
    backLabelKey: "tour_detail_back_adventure",
    relatedSlugs: ["adventure-01", "adventure-03"],
    startValueKey: "adventure_2_start",
    startLabelKey: "adventure_2_start_label",
    isSailing: true,
  },
  {
    slug: "adventure-03",
    category: "adventure",
    titleKey: "adventure_3_title",
    subtitleKey: "adventure_3_subtitle",
    image: img("activities/adventure-tours/adventure-3/header-adventure-3.jpg"),
    sliderImages: [
      { src: img("activities/adventure-tours/adventure-3/diving-slide-01.jpg"), alt: "Taucher über Korallengarten Nord Bali" },
      { src: img("activities/adventure-tours/adventure-3/diving-slide-02.jpg"), alt: "Tauchboot Nord Bali" },
      { src: img("activities/adventure-tours/adventure-3/diving-slide-03.jpg"), alt: "Tropische Korallenfische Nord Bali" },
      { src: img("activities/adventure-tours/adventure-3/diving-slide-04.jpg"), alt: "Mantarochen in Balis Gewässern" },
    ],
    tagKey: "adventure_3_tag",
    durationKey: "adventure_3_duration",
    detailDescKey: "adventure_3_detail",
    hasItinerary: false,
    highlightsKey: "adventure_3_highlights",
    includedKeys: ["adventure_3_incl_1", "adventure_3_incl_2", "adventure_3_incl_3", "adventure_3_incl_4", "adventure_3_incl_5"],
    backPath: "/adventure-tours",
    backLabelKey: "tour_detail_back_adventure",
    relatedSlugs: ["adventure-01", "adventure-02"],
    startValueKey: "adventure_3_start",
    startLabelKey: "adventure_3_start_label",
    isDiving: true,
    externalLink: "https://balidivecenter.com/",
  },
  {
    slug: "adventure-04",
    category: "adventure",
    titleKey: "adventure_4_title",
    subtitleKey: "adventure_4_subtitle",
    image: img("activities/adventure-tours/adventure-4/header-adventure-4.jpg"),
    tagKey: "adventure_4_tag",
    durationKey: "adventure_4_duration",
    detailDescKey: "adventure_4_detail",
    hasItinerary: false,
    highlightsKey: "adventure_4_detail",
    includedKeys: ["tour_included_1", "tour_included_3", "tour_included_4"],
    backPath: "/adventure-tours",
    backLabelKey: "tour_detail_back_adventure",
    relatedSlugs: ["adventure-01", "adventure-02", "adventure-03"],
  },
];